export default __webpack_public_path__ + "static/media/legal-lock.331ed2d4.png";